import { render, staticRenderFns } from "./Lightnovel.vue?vue&type=template&id=1efc6538&"
import script from "./Lightnovel.vue?vue&type=script&lang=js&"
export * from "./Lightnovel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports